import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';
import { UtilsService } from 'src/app/services/utils.service';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-file-thumbnail',
  templateUrl: './file-thumbnail.component.html',
  styleUrls: ['./file-thumbnail.component.scss']
})
export class FileThumbnailComponent implements OnInit {

  @Input() thumbnail:[];
  @Input() fileTarget:string;

  @Input() configRef:any;
  @Input() contentDataRef:any;
  @Input() selectedFolderRef:any;
  @Input() utilsRef:UtilsService;
  @Input() moduleIdRef:UtilsService;
  
  
  
  title:string;

  @Output()
  fileSelect:EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private _firebase: FirebaseService,
    public translation: TranslationPipe
  ) { }

  ngOnInit() {

    //console.log('👉 selectedFolderRef', this.selectedFolderRef.id);

    if (this.fileTarget == 'bg') {
      this.title = this.translation.transform('backgroundImage') as string;
    }

    else{
    

      this.title = this.translation.transform('thumbnailButton') as string;
    }

    
  }

  prepareForUpload(e, type){
    
    
    
    const datas = [e, type];
    
    
    
    

 

   let rootAsset;

 
    if (this.selectedFolderRef != 'root')
      rootAsset = null;
    else
      rootAsset = this.configRef.rootBackgroundAsset;


 
    this._firebase.removePreviousImg(this.selectedFolderRef.id, type, rootAsset).then(() => {
      this._firebase.uploadFiles(e.target.files[0], 'media').then((d) => {
      
        let getFilenameFromUrl = (url) => {
          // Create a URL object
          const parsedUrl = new URL(url);
          // Get the pathname and extract the last segment
          const pathname = parsedUrl.pathname;
          const filename = decodeURIComponent(pathname.split('/').pop());
          return filename.split('/').pop();
        }


        let path = `users/${this._firebase.user.displayName}/media/` + `${getFilenameFromUrl(d)}`
     
        if (type == 'background') {


          if (this.selectedFolderRef == undefined || this.selectedFolderRef.id == undefined || this.selectedFolderRef.id == null || Object.keys(this.selectedFolderRef).length == 0) {
           
          

            this.thumbnail = d;
            this._firebase.updateConfigModule({ fileTree: this.contentDataRef, rootBackgroundAsset: d }, this.moduleIdRef)
          }
          else {
            this._firebase.updateMediaData({ background: { firestoragePath: path, url: d } }, this.selectedFolderRef.id)
            this.thumbnail = d;

            this.utilsRef.updateElement(this.contentDataRef, this.selectedFolderRef.id, 'backgroundAssetName', e.target.files[0].name)
            this._firebase.updateConfigModule({ fileTree: this.contentDataRef }, this.moduleIdRef)
          }


        }
        else if (type == 'thumbnail') {

          this._firebase.updateMediaData({ thumbnail: { firestoragePath: path, url: d } }, this.selectedFolderRef.id)
          this.thumbnail = d;



          this.utilsRef.updateElement(this.contentDataRef, this.selectedFolderRef.id, 'thumbnailAssetName', e.target.files[0].name)
          this._firebase.updateConfigModule({ fileTree: this.contentDataRef }, this.moduleIdRef)
        }
      })
    })

    
  }



}
